import { DocumentBlock } from "@entities/journal";
import "./section-fourth-documents.scss";
import { SectionFourDocTypeEnum, SectionFourDocTypeTypes } from "../../../../model";

interface Document {
  id?: string;
  docId?: string;
  docType?: string;
  fileName?: string;
  name?: string;
  file_id?: string;
  documentUrl?: string;
}

interface SectionFourthDocumentsProps {
  docs?: Document[];
  otherDocuments?: Document[];
}

export const SectionFourthDocuments = ({
  docs = [],
  otherDocuments = [],
}: SectionFourthDocumentsProps) => {
  const getDocsByType = (type: SectionFourDocTypeEnum) => {
    return docs.filter((doc) => doc.docType === type);
  };

  const regulationDocs = getDocsByType(SectionFourDocTypeTypes.REGULATION_DOC);
  const supportingDocs = getDocsByType(SectionFourDocTypeTypes.SUPPORTING_DOC);
  const projectDocs = getDocsByType(SectionFourDocTypeTypes.PROJECT_DOC);
  const workDocs = getDocsByType(SectionFourDocTypeTypes.WORK_DOC);
  const laboratoryDocs = getDocsByType(SectionFourDocTypeTypes.LABORATORYDATA_DOC);

  const additionalDocs = docs.filter((doc) => !doc.docType ||
    !Object.values(SectionFourDocTypeTypes).includes(doc.docType as SectionFourDocTypeEnum),
  );

  const hasDocuments =
    regulationDocs.length > 0 ||
    supportingDocs.length > 0 ||
    projectDocs.length > 0 ||
    workDocs.length > 0 ||
    laboratoryDocs.length > 0 ||
    additionalDocs.length > 0 ||
    otherDocuments.length > 0;

  if (!hasDocuments) {
    return null;
  }

  return (
    <div className="section-fourth-documents">
      <div className="section-fourth-documents__section">
        <div className="section-fourth-documents__title">Документы</div>

        <div className="section-fourth-documents__list">
          {regulationDocs.map((doc) => (
            <DocumentBlock
              key={doc.id || doc.docId}
              title="Нормативная документация"
              fileName={doc.name || doc.fileName}
              documentUrl={doc.documentUrl}
              docType={SectionFourDocTypeTypes.REGULATION_DOC}
              docId={doc.docId}
            />
          ))}

          {supportingDocs.map((doc) => (
            <DocumentBlock
              key={doc.id || doc.docId}
              title="Сопроводительные документы(необязательная)"
              fileName={doc.name || doc.fileName}
              documentUrl={doc.documentUrl}
              docType={SectionFourDocTypeTypes.SUPPORTING_DOC}
              docId={doc.docId}
            />
          ))}

          {projectDocs.map((doc) => (
            <DocumentBlock
              key={doc.id || doc.docId}
              title="Проектная документация"
              fileName={doc.name || doc.fileName}
              documentUrl={doc.documentUrl}
              docType={SectionFourDocTypeTypes.PROJECT_DOC}
              docId={doc.docId}
            />
          ))}

          {workDocs.map((doc) => (
            <DocumentBlock
              key={doc.id || doc.docId}
              title="Рабочая документация"
              fileName={doc.name || doc.fileName}
              documentUrl={doc.documentUrl}
              docType={SectionFourDocTypeTypes.WORK_DOC}
              docId={doc.docId}
            />
          ))}

          {laboratoryDocs.map((doc) => (
            <DocumentBlock
              key={doc.id || doc.docId}
              title="Документы, подтверждающие исправление недостатков"
              fileName={doc.name || doc.fileName}
              documentUrl={doc.documentUrl}
              docType={SectionFourDocTypeTypes.LABORATORYDATA_DOC}
              docId={doc.docId}
            />
          ))}

          {additionalDocs.map((doc) => (
            <DocumentBlock
              key={doc.id || doc.docId}
              title="Дополнительные файлы"
              fileName={doc.name || doc.fileName}
              documentUrl={doc.documentUrl}
              docType="ADDITIONAL_DOC"
              docId={doc.docId}
            />
          ))}

          {otherDocuments.map((doc) => (
            <DocumentBlock
              key={doc.id || doc.file_id}
              title="Дополнительные файлы"
              fileName={doc.fileName || doc.name || "document.pdf"}
              fileId={doc.file_id}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
